import type { ProfileQueryRequest } from "@/services/api/companies";

export function isFilterValueActive(
  value: string | number | boolean | string[] | null | undefined
): boolean {
  if (value === undefined || value === null) return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "string") return value.trim() !== "";
  return true;
}

export function normalizeValue(value: string): string | undefined {
  return value.trim() || undefined;
}

export function normalizeNumber(value: string): number | undefined {
  const num = value.trim();
  return num ? Number(num) : undefined;
}

export function getActiveFiltersCount(
  filters: Partial<ProfileQueryRequest>
): number {
  return Object.keys(filters).filter(
    (key) =>
      key !== "page" &&
      key !== "pageSize" &&
      key !== "sortBy" &&
      key !== "sortDirection" &&
      isFilterValueActive(filters[key as keyof ProfileQueryRequest])
  ).length;
}

export function hasActiveFilters(
  filters: Partial<ProfileQueryRequest>
): boolean {
  return Object.keys(filters).some(
    (key) =>
      key !== "page" &&
      key !== "pageSize" &&
      key !== "sortBy" &&
      key !== "sortDirection" &&
      isFilterValueActive(filters[key as keyof ProfileQueryRequest])
  );
}

export function formatExperienceMonths(months: number | null): string {
  if (months === null || months === 0) {
    return "—";
  }

  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  const parts: string[] = [];
  if (years > 0) {
    parts.push(`${years}y`);
  }
  if (remainingMonths > 0) {
    parts.push(`${remainingMonths}m`);
  }

  return parts.length > 0 ? parts.join(" ") : "0m";
}
